import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'scPaymentNumberPipe' })
export class PaymentNumberPipe implements PipeTransform {
    transform(number: string) {
        return number && number.replace(/#/g, '•');
    }
}